import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-approval-thumb',
  templateUrl: './icon-approval-thumb.component.html',
  styleUrls: ['./icon-approval-thumb.component.scss'],
})
export class IconApprovalThumbComponent {
  @Input() color = '#064e3b';
  @Input() width = '12';
  @Input() height = '12';
}
